module.exports = __webpack_public_path__ + "static/media/gb-eng.38e503b0.svg";